import { swap } from '@/utils/swap';
export const SCROLL_END_THROTTLE_LIMIT = 1_500;
export const timezoneOffsetMillis = new Date().getTimezoneOffset() * 60 * 1_000;
export const ORDER_EVENT_TIMER = 3_000;
export const APP_TICK_INTERVAL = 5_000;
// 타이머 순환(적당한 값) - 7시간(배달 표시시간 6시간 + 1시간)
export const INTERVAL_CYCLE_BIT = (7 * 60 * 60 * 1_000) / APP_TICK_INTERVAL;
export const DB_CLICK_DELAY = 200;
export { default as orderTypeCode } from './orderTypeCode';
// 허브 소속 상점 전체
export const ALL_STORE_ID = 'S000000';
// 공유 주문 노출 여부
export const shareDisplayType = {
    Y: 'Y',
    N: 'N',
};
/**
 * 배차 구분 (즉시배차, 재배차)
 */
export const allocateWorkerType = {
    IMMEDIATE: 'IMMEDIATE',
    REALLOCATE: 'REALLOCATE',
    REQUEST_ALLOCATE: 'REQUEST_ALLOCATE',
};
/**
 * 글로벌 얼럿 종류. alert, confirm 구분
 */
export const globalAlertType = {
    ALERT: 'alert',
    CONFIRM: 'confirm',
    REMOVE: 'remove',
};
export const sortTypeEnum = {
    ASC: 'asc',
    DESC: 'desc',
};
/**
 * 최상위 도메인
 */
export const domainEnum = {
    HUB: 'HUB',
    DISTRIBUTOR: 'DISTRIBUTOR',
    STORE: 'STORE',
    WORKER: 'WORKER',
};
/**
 * 수행상황
 */
export const fulfillmentState = {
    GOOD: 1,
    DELAY: 2,
    STOP: 3,
};
/**
 * keyCode
 * 대소문자 구분 없음. q면 Q이고 ㅂ 이다.
 */
export const keyboardEnum = {
    ENTER: 13,
    ESC: 27,
    Q: 81,
    E: 69,
    A: 65,
};
/**
 * {
 * 13: ENTER,
 * 27: ESC
 * }
 */
export const keyboardType = (() => swap(keyboardEnum))();
/**
 * 단축키
 */
export const shortcut = {
    /** 확인 */
    enter: keyboardEnum.ENTER,
    /** 취소 */
    cancel: keyboardEnum.ESC,
    /** request allocate 배차 요청 */
    requestAllocate: keyboardEnum.Q,
    /** reallocate 재배차 (r은 새로고침과 중복) */
    reallocate: keyboardEnum.E,
    /** allocate 배차 */
    allocate: keyboardEnum.A,
};
// figma link
// https://www.figma.com/file/MC48vUUguBidnS5y7rZFnb/%5BBAROGO%5D-Design-System_Vuetify?node-id=3-4&t=66N2Sdb3tRl4kNPW-11
export const buttonConfig = {
    // ui 스타일을 담당
    // 각 스타일은 outlined css를 추가해서 outlined 스타일을 줄 수도 있음.
    // default: primary
    style: [
        'primary',
        'danger',
        'info',
        'orange',
    ],
    // 가로폭을 담당. 지정하지 않으면 글자수만큼 늘어남
    // default: none
    width: [
        'width-xxs',
        'width-xs',
        'width-s',
        'width-m',
        'width-fill',
    ],
    // 높이와 글자의 좌우여백을 담당
    // default: size-m value
    size: [
        'size-xxs',
        'size-xs',
        'size-s',
        'size-m',
        'size-l',
        'size-xl',
    ],
    // font-weight
    fw: [
        'fw-b',
    ],
    // disabled는 vuetify 기본 제공되는 v-btn disabled 속성을 이용.
};
// 타임존 코드
export const timeZoneCode = {
    UTC: 'UTC',
    KR: 'KR',
};
// van 한글 매퍼 enum
// slack: https://barogo.slack.com/archives/C04UP4VFCKA/p1692929943105679?thread_ts=1692928864.709669&cid=C04UP4VFCKA
/* eslint-disable quote-props */
export const vanCodeEnum = {
    '01': 'KSNET',
    '02': 'KIS',
    '03': 'KOCES',
    '04': 'JTNET',
    '05': 'SMARTRO',
    '06': 'SMARTRO-PG',
    '07': 'KICC-PG',
    '08': 'KICC-IC',
    '09': 'KIS-IC',
    '10': 'SMARTRO-IC',
    '11': 'KCP(엠씨페이)',
    '12': 'KCP(체크모바일)',
    '99': '없음',
};
/** 주소기반 주문 판단 기준 B7443허브의 주문 */
export const addressBaseOrder = [
    'B7443',
];
/**
 * 바로고 본사 위경도
 */
export const barogoHQLatLng = [
    37.5168838,
    127.038268,
];
